module.exports = __webpack_public_path__ + "static/images/components/Pagination/PaginationArrowButton/images/pagination-arrow_disable.07a13211.png";


//////////////////
// WEBPACK FOOTER
// ./components/Pagination/PaginationArrowButton/images/pagination-arrow_disable.png
// module id = 2654
// module chunks = 11